import { FREE_VISIBLE_SITES, ScanFrequency } from './enums';
import { DAY_MS } from './timings';
import type { LiveSite, LiveSnapshot } from './api-types';

/**
 * What a client sees of her sites before she pays: the first few by name, the
 * rest locked, with the name masked and no links. The API and the admin
 * preview both lock through this, so the preview cannot show what she sees wrongly.
 */
export function lockSites(sites: LiveSite[], paying: boolean): LiveSite[] {
  return sites.map((site, index) => {
    const locked = !paying && index >= FREE_VISIBLE_SITES;
    return locked ? { ...site, domain: maskedDomain(site.domain), locked, links: [] } : { ...site, locked: false };
  });
}

/** A locked site: the first letter and the ending, so it reads as a real place. */
export function maskedDomain(domain: string): string {
  const dot = domain.lastIndexOf('.');
  return `${domain[0]}${'•'.repeat(Math.max(4, dot - 1))}${domain.slice(dot)}`;
}

/** The four counts over the sites the screen lists, for the API and the admin preview alike. */
export function liveTotals(sites: LiveSite[]): LiveSnapshot['totals'] {
  return {
    links: sites.reduce((sum, site) => sum + site.linkCount, 0),
    sites: sites.length,
    inGoogle: sites.reduce((sum, site) => sum + site.inGoogle, 0),
    online: sites.flatMap((site) => site.links).filter((link) => link.online).length,
  };
}

/** When the plan searches again after `last`; null for a plan that searches once. */
export function nextSearchAt(last: Date, frequency: ScanFrequency): string | null {
  const every = frequency === ScanFrequency.DAILY ? DAY_MS : frequency === ScanFrequency.WEEKLY ? 7 * DAY_MS : null;
  if (!every) return null;
  return new Date(Math.max(Date.now(), last.getTime() + every)).toISOString();
}
